var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-list", {
    attrs: {
      dataList: _vm.datas,
      size: _vm.size,
      tagLists: _vm.tagLists,
      tagType: "userStatus",
      listId: "arrId",
      listName: "arrName",
    },
    on: { "to-list": _vm.toList, "to-more": _vm.toListMore },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var list = ref.list
          return [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_ote_lbl_minutes" /* 时间 */)) +
                  "：" +
                  _vm._s(
                    _vm.getDateTimeFormatted({
                      startTime: list.entryStartTime,
                      endTime: list.entryEndTime,
                    })
                  )
              ),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }